module.exports = __webpack_public_path__ + "img/svg/blog.99bbe157f32c9c18a9c2646139510387.svg";